<template>
  <MainLayout
    :initialDrawerExpanded="false"
    contentClass="pa-0"
    :has-sidebar="false"
  >
    <template #header>
      <div class="d-flex align-center">
        <PageBack class="mr-2" />
        <span class="subtitle-2 grey--text text--darken-1">À propos</span>
      </div>
    </template>

    <template #content>
      <AboutContent />
    </template>
  </MainLayout>
</template>

<script>
import PageBack from '@/components/ui/PageBack.vue'
import MainLayout from '@/layout/MainLayout.vue'
import AboutContent from '@/components/AboutContent.vue'

export default {
  name: 'AboutView',
  components: { PageBack, MainLayout, AboutContent },
}
</script>
